import React from 'react';
import { ServiceAgreementV2 } from 'pco-product-service-internal-consumer';
import { getConfigureProductGroupModal } from './configureProductModalRegistry';

type ConfigureProductModalProps = {
  serviceAgreement: ServiceAgreementV2;
  brUid: string;
  relatedServiceAgreementNames?: string[];
  relatedServiceAgreementUids?: string[];
};

export const ConfigureProductModal: React.FC<ConfigureProductModalProps> = ({
  serviceAgreement,
  brUid,
  relatedServiceAgreementNames = [],
  relatedServiceAgreementUids = [],
}) =>
  React.createElement(getConfigureProductGroupModal(serviceAgreement.serviceDefinitionId), {
    serviceAgreement,
    brUid,
    relatedServiceAgreementNames,
    relatedServiceAgreementUids,
  });
